import React, { useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Avatar from '../assets/images/users/avt1.png'
import Button from 'react-bootstrap/Button';
import { BiCalendarPlus } from "react-icons/bi";
import InputGroup from 'react-bootstrap/InputGroup';
import Form from 'react-bootstrap/Form';
import { BiSearchAlt, BiCalendar, BiBarChartAlt2, BiLogIn } from "react-icons/bi";
import axios from 'axios';
import { Buffer } from 'buffer';
import { useNavigate } from 'react-router-dom';
import { callMsGraph } from '../callMsGroup';
import { useParams } from "react-router-dom";
import {
    useMsal,
    MsalAuthenticationTemplate,
    useIsAuthenticated,
} from "@azure/msal-react";
import {
    InteractionType,
    InteractionStatus,
    IPublicClientApplication,
    AccountInfo,
} from "@azure/msal-browser";
import LoadingScreen from './LoadingScreen';
import ScreenLoadingLogin from './ScreenLoadingLogin';
export default function MyTopbar(props: any) {
    let { eventnumber }: any = useParams();
    const [isAdmin, setIsAdmin] = useState(false);
    const [keyword, setKeyword] = useState("");
    const { inProgress, instance, accounts } = useMsal();
    const isAuthenticated = useIsAuthenticated();
    const [photoData, setPhotoData] = useState("");
    const [token, setToken] = useState("");
    const [apiToken, setApiToken] = useState("");
    const [profile, setProfile] = useState({ jobTitle: "" });
    const [success, setSuccess] = useState(false);
    const navigate = useNavigate();

    const hendelChange = (e: any) => {
        const { value, name } = e.target
        setKeyword(value)
    }
    const hendleEnter = (e: any) => {
        if (e.keyCode === 13) {
            onSearch()
        }
    }
    const onSearch = () => {

        props.triggerSearch(keyword);
    }
    return (
        <>
            <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
                <Navbar bg="white" data-bs-theme="light" className='px-2 ' sticky="top">
                    <div className='container-fluid'>
                        <Navbar.Brand onClick={() => navigate('/')} style={{cursor:"pointer"}}>C&S Events</Navbar.Brand>
                        <Nav className="me-auto top-menu ms-4">
                        <Nav.Link onClick={() => navigate('/myevents')} className='active'>
                            <BiCalendar size={20} /> My Events
                        </Nav.Link>
                        { eventnumber && (
                            <Nav.Link onClick={() => navigate(`/event/${eventnumber}/report`)}>
                                <BiBarChartAlt2 size={20} /> Report
                            </Nav.Link>
                        )}
</Nav>
                        <Nav>
                            {/* <div className='border-end pe-3 search-bar'>
                                <div className="input-group">
                                    <input type="text" className="form-control" aria-describedby="basic-addon2" onChange={(e: any) => hendelChange(e)} onKeyDown={(e: any) => hendleEnter(e)} value={keyword} />
                                    <span className="input-group-text" id="basic-addon2" onClick={() => onSearch()}><BiSearchAlt /></span>
                                </div>
                            </div> */}
                            <img src={(props.photoData === "") ? Avatar : props.photoData} className='admin-img border ms-3' />
                            <div className='user-profile me-4'>
                                <label>{accounts[0]?.name}</label>
                                <p>
                                    <a className='text-gray' href={`${window.location.origin}/myevents`}>My Events</a>
                                </p>
                            </div>
                            {/* <div className='add-event ps-3 border-start me-4'>
                                <a className="btn   create-event-btn" href={'/events'}>
                                    <BiCalendarPlus /> <span>Create Event</span>
                                </a>
                            </div> */}
                            {/* <div>
                                <BiLogIn className='logOut' onClick={() => handleLogout()} />
                            </div> */}
                        </Nav>
                    </div>
                </Navbar>
            </MsalAuthenticationTemplate>
        </>
    )
}
